<template>
    <a-spin :spinning="loading.page" tip="Loading...">
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-card class="m-display-flex flex-column nowrap">
          <span slot="title">{{ mode }} Payment Instruction</span>
          <!-- <div class="steps-content flex-1"> -->
            <a-form :form="form.main">
              <a-row :gutter="12">
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                  <a-form-item label="PP">
                    <a-select
                      showSearch
                      v-decorator="[
                        'id_pp',
                        {
                          rules: [{ required: true }], initialValue: dataEdit.id_dtl
                        },
                      ]"
                      class="select-between"
                      @change="handleChangePP"
                      ref="refid_pp"
                      optionFilterProp="children"
                      :filterOption="filterOptionPP"
                      :disabled="mode == 'Edit' || linkCreate"
                    >
                      <a-select-option
                        v-for="item in selectSource.pp"
                        :key="item.id_pp"
                      >
                        <div style="display: flex;justify-content: space-between;opacity: 1;width: 100%;">
                          <span>[{{ item.no_pp }}] {{ item.deskripsi }}</span>
                          <span style="float: right;"><b>{{
                            formatCurrency(
                              item.currency,
                              parseFloat(item.estimated_value)
                            )
                          }}</b></span>
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="m-form-description-small">
                    <a-row :gutter="12" class="margin-top">
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <ul class="m-list-wrapper bordered">
                          <li>
                            <span class="m-list-title" for>Created Date</span>
                            <span class="m-list-desc">{{
                              selectSource.desc_pp.tgl_buat ?
                              moment(selectSource.desc_pp.tgl_buat).format(
                                getDefaultDateFormat
                              ) : "-"
                            }}</span>
                          </li>
                          <li>
                            <span class="m-list-title" for>User Creator</span>
                            <span class="m-list-desc">{{ selectSource.desc_pp.pembuat ? selectSource.desc_pp.pembuat : "-" }}</span>
                          </li>
                        </ul>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <ul class="m-list-wrapper bordered">
                          <li>
                            <span class="m-list-title" for>Cost Center</span>
                            <span class="m-list-desc">{{ selectSource.desc_pp.kode_project ? selectSource.desc_pp.kode_project : "-" }}</span>
                          </li>
                          <li>
                            <span class="m-list-title" for>Financial Item / Code</span>
                            <span class="m-list-desc">
                              {{ selectSource.desc_pp.deskripsi ? selectSource.desc_pp.deskripsi : "-" }} / 
                              {{ selectSource.desc_pp.no_pp ? selectSource.desc_pp.no_pp : "-" }}
                            </span>
                          </li>
                        </ul>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <ul class="m-list-wrapper bordered">
                          <li>
                            <span class="m-list-title" for>Be Required</span>
                            <span class="m-list-desc">{{
                              selectSource.desc_pp.be_required ?
                              moment(selectSource.desc_pp.be_required).format(
                                getDefaultDateFormat
                              ) : "-"
                            }}</span>
                          </li>
                          <li>
                            <span class="m-list-title" for>End User</span>
                            <span class="m-list-desc">{{ selectSource.desc_pp.end_user ? selectSource.desc_pp.end_user : "-" }}</span>
                          </li>
                        </ul>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <ul class="m-list-wrapper bordered">
                          <li>
                            <span class="m-list-title" for>Currency</span>
                            <span class="m-list-desc">{{ selectSource.desc_pp.currency ? selectSource.desc_pp.currency : "-" }}</span>
                          </li>
                          <li>
                            <span class="m-list-title" for>Value</span>
                            <span class="m-list-desc">
                              {{ selectSource.desc_pp.deskripsi ?
                                formatCurrency(selectSource.desc_pp.currency, selectSource.desc_pp.estimated_value) : "-" }}
                            </span>
                          </li>
                        </ul>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
                <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-item label="PP Detail">
                    <a-select
                      showSearch
                      v-decorator="[
                        'id_pp_dtl',
                        {
                          rules: [{ required: true }], initialValue: dataEdit.id_dtl
                        },
                      ]"
                      class="select-between"
                      @change="handleChangePPDtl"
                      ref="refid_pp_dtl"
                      optionFilterProp="children"
                      :filterOption="filterOptionPP"
                      :loading="loading.ppdtl"
                      :disabled="loading.ppdtl"
                    >
                      <a-select-option
                        v-for="item in selectSource.ppdtl"
                        :key="item.id_pp_dtl"
                      >
                        <div style="display: flex;justify-content: space-between;opacity: 1;width: 100%;">
                          <span>[{{ item.nama_anggaran }}]</span>
                          <span style="float: right;"><b>{{
                            formatCurrency(
                              item.currency,
                              parseFloat(item.harga)
                            )
                          }}</b></span>
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Is TAX?">
                    <a-radio-group
                        buttonStyle="solid"
                        v-decorator="[
                          'is_tax',
                          { rules: [{ required: true }], initialValue: dataEdit.is_tax },
                        ]"
                        @change="changeIsTax"
                    >
                        <a-radio-button value="0">No</a-radio-button>
                        <a-radio-button value="1">Yes</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                  <a-form-item label="Tax Type" v-if="form.tax">
                    <a-select v-decorator="['tax_type', { rules: [{ required: true }], initialValue: dataEdit.tax_type }]"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option
                          v-for="item in getType_tax"
                          :key="item.value"
                          :value="item.value"
                      >
                      {{ item.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-divider></a-divider>
                  <a-button
                    type="primary"
                    class="m-width-full"
                    @click="save"
                    :loading="loading.save"
                    >Add Detail</a-button
                  >
                </a-col> -->
              </a-row>
            </a-form>
          <!-- </div> -->

          <div class="container-headertable margin-top">
              <div class="m-display-flex space-between align-middle">
                  <span>Usage Details</span>
              </div>
          </div>
          <a-card>
            <a-spin :spinning="loading.table" tip="Loading...">
              <a-input-search v-model="dataSource.search" placeholder="Search" />
                <a-form-model
                  ref="dynamicValidateForm"
                  :model="dynamicValidateForm"
                  class="steps-content m-flex1"
                > 
                <a-table
                  bordered
                  size="small"
                  id="tbl_dtl"
                  class="margin-top"
                  :rowKey="(record, index) => { return index; }"
                  :columns="columns.usagedetail"
                  :dataSource="usageDtl"
                  :pagination="pagination.usagedetail"
                  :scroll="{ x: 525 }"
                >
                <template slot="nomor" slot-scope="text, record, index">
                  {{ index+1 }}
                </template>
                <template slot="itemName" slot-scope="record">
                  {{ record.nama_barang }}
                </template>
                <template slot="typetax" slot-scope="text, record, index">
                  <a-form-model-item
                  :key="index"
                  :prop="'domains.' + index + '.value'"
                  :rules="{
                    required: true,
                    message: 'Tax Type can not be empty!',
                    trigger: 'change',
                  }"
                  >
                  <a-select
                    v-model="dataSource.usagedetail[record.noindex].tax_type"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    :filterOption="filterOption"
                    placeholder="Choose Type Tax"
                    class="m-width-full"
                    @change="(e)=>changetype(e, record.noindex)"
                  >
                  <a-select-option
                        v-for="item in listtax"
                        :key="item.value"
                        :value="item.value"
                    >
                    {{ item.text }}
                    </a-select-option>
                  </a-select>
                  </a-form-model-item>
                </template>
                <template slot="qty" slot-scope="record">
                  {{ record.jumlah_barang }} {{ record.satuan }}
                </template>
                <template slot="unitprice" slot-scope="record">
                  <CurrencyJustified
                    :currencyValue="record.currency"
                    :valueNumber="record.harga"
                  />
                </template>
                <template slot="amount" slot-scope="record">
                  <CurrencyJustified
                      :currencyValue="record.currency"
                      :valueNumber="record.jumlah_barang * record.harga"
                    />
                </template>
                <div slot="footer">
                  <a-row :gutter="12">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
                      <h3>Grand Total</h3>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 20 }">
                      <h3>{{ dataSource.usagedetail.length==0 ? 0 : grandtotal }}</h3>
                    </a-col>
                  </a-row>
                </div>
                </a-table>
                </a-form-model>
            </a-spin>
          </a-card>

          <template  slot="actions">
            <div class="steps-action">
              <a-button
                type="primary"
                @click="submitForm('dynamicValidateForm')"
                :loading="loading.save"
                >Save</a-button
              >
            </div>
          </template>
        </a-card>
      </a-config-provider>
    </a-spin>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import GlobalMethod from "@/mixins/GlobalMethod";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import moment from "moment";
  import _ from "lodash";
  
  export default {
    name: "PICreate",
    props: ["id"],
     mixins: [CurrencyFormat, GlobalMethod],
    data() {
      const columns_1 = [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
          align: "center",
        },
        {
          title: "Item Name",
          key: "name",
          scopedSlots: { customRender: "itemName" },
          width: 200,
        },
        {
          title: "Type Tax",
          key: "typetax",
          scopedSlots: { customRender: "typetax" },
          width: 150,
        },
        {
          title: "Quantity",
          key: "qty",
          scopedSlots: { customRender: "qty" },
          width: 100,
        },
        {
          title: "Unit Price",
          key: "unitprice",
          scopedSlots: { customRender: "unitprice" },
          width: 100,
        },
        {
          title: "Amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
          width: 100,
        },
      ];
    
      return {
        mode: "Create",
        loading: {
          page: false,
          save: false,
          ppdtl: false,
          table:false,
        },
        dataSource: {
          search:null,
          usagedetail: []
        },
        columns: {
          usagedetail: columns_1
        },
        pagination: {
          usagedetail: {
            onChange: (page) => {
              this.pagination.page = page;
            },
            page: 1,
            pageSize: 10,
            size: "small",
          },
        },
        form: {
          main: this.$form.createForm(this),
          tax: false,
        },
        selectSource: {
          pp: [],
          ppdtl: [],
          desc_pp:[]
        },
        dataEdit: {
          is_tax: "0"
        },
        dynamicValidateForm: {
          domains: [],
        },
      }
    },
    computed: {
      ...mapGetters([
        "getAuth",
        "getDefaultDateFormat",
        "getAllKaryawan",
        "getStandartFormatDate",
        "getType_tax"
      ]),
      grandtotal() {
        let result = 0;
        let curr = null;
        _.forEach(this.dataSource.usagedetail, item => {
          result = result + Number(item.jumlah_barang * item.harga);
          if (!curr)
            curr = item.currency;
        });
        return this.formatCurrency(curr,result);
      },
      usageDtl() {
        let a = [];
        if (this.dataSource.search) {
          a = _.filter(this.dataSource.usagedetail, (item) =>
            item.nama_barang.toLowerCase().indexOf(this.dataSource.search.toLowerCase()) >= 0 ||
            (item.tax_type && this.getlabeltax(item.tax_type).toLowerCase().indexOf(this.dataSource.search.toLowerCase()) >=0)
          );
        } else {
          a = this.dataSource.usagedetail;
        }
        return a;
      },
      listtax() {
        let a = [];
        a.push({
          text: "Non Tax",
          value: "undefined"
        });
        this.getType_tax.forEach(element => {
          a.push(element);
        });
        return a;
      },
      linkCreate() {
        let path_r = (this.$route.path).split("/");
        let res = false;

        if (path_r[path_r.length - 2] == "Create" && this.id)
          res = true;

        return res;
      }
  },
  beforeCreate() {
    this.formHeadPendanaan = this.$form.createForm(this);
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");

    if (this.id && !this.linkCreate) {
      this.mode = "Edit";
      this.loading.page = true;
      this.asyncAxiosGet("pi/edit",
        this.getAuth,
        {
        id_pi: this.id
        }
      ).then((res) => {
        this.selectSource.pp = res.pp_hdr;
        this.dataEdit.id_dtl = res.pp_hdr[0].id_pp;
        this.dataSource.usagedetail = res.pp_dtl;

        this.dataSource.usagedetail[0].noindex = 0;
        this.selectSource.desc_pp.tgl_buat = res.pp_hdr[0].tanggal;
        this.selectSource.desc_pp.pembuat = res.pp_hdr[0].user_pembuat;
        this.selectSource.desc_pp.kode_project = res.pp_hdr[0].kode_project;
        this.selectSource.desc_pp.deskripsi = res.pp_hdr[0].deskripsi;
        this.selectSource.desc_pp.no_pp = res.pp_hdr[0].no_pp;
        this.selectSource.desc_pp.be_required = res.pp_hdr[0].be_required;
        this.selectSource.desc_pp.end_user = res.pp_hdr[0].end_user;
        this.selectSource.desc_pp.currency = res.pp_hdr[0].currency;
        this.selectSource.desc_pp.estimated_value = res.pp_hdr[0].estimated_value;

        for (let x = 0; x < this.dataSource.usagedetail.length; x++) {
          this.dynamicValidateForm.domains.push({ key: x, value: this.dataSource.usagedetail[x].tax_type });
        }
      
        this.loading.page = false;
      }).catch((err) => {
        this.loading.page = false;
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-other", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        }
      });
    } else {
      this.getPP();
    }
  },
  methods: {
    ...mapActions([]),
    moment,
    getPP() {
      this.loading.page = true;
      this.asyncAxiosGet("pi/pp_pi",
        this.getAuth,
      ).then((res) => {
        this.selectSource.pp = res.data_pp;

        if (this.linkCreate) {
          this.dataEdit.id_dtl = this.id;
          this.handleChangePP(this.id);
        }

        this.loading.page = false;
      })
      .catch((err) => {
        this.$router.go(-1);
      //   this.loading.page = false;
      //   let response = Object.assign({}, err.response);
      //   if (response.data.status == false && response.data.message) {
      //     this.displayMessageValue("error-other", response.data.message);
      //   } else {
      //     let responses = Object.assign({}, err.response.data);
      //     this.displayMessageValue("error", responses);
      //   }
      });
    },
    getPPDtl(idpp) {
      this.loading.table = true;
      this.asyncAxiosGet("pi/pp_dtl",
        this.getAuth,
        {
          id_pp: idpp
        }
      ).then((res) => {
        this.selectSource.ppdtl = res.pp_dtl;
        this.dataSource.usagedetail = res.pp_dtl;
        for (let x = 0; x < this.dataSource.usagedetail.length; x++) {
          this.dataSource.usagedetail[x].noindex = x;
          this.dataSource.usagedetail[x].tax_type = undefined;
          this.dynamicValidateForm.domains.push({ key: x, value: null });
        }

        this.loading.table = false;
      }).catch((err) => {
        this.loading.table = false;
        let response = Object.assign({}, err.response);
        let responses = Object.assign({}, response);
          this.displayMessageValue("error", responses);
      });
    },
    filterOptionPP(input, option) {
      return (
        option.componentOptions.children[0].children[0].children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleChangePP(val) {
      let resfil = _.filter(this.selectSource.pp, (item) => item.id_pp == val);
      this.selectSource.desc_pp = resfil[0];
      this.$nextTick(function () {
      this.form.main.setFieldsValue({
        id_pp_dtl: null,
        });
      });
      this.getPPDtl(val);
    },
    handleChangePPDtl() {
      
    },
    changeIsTax() {
      this.form.tax = !this.form.tax;
    },
    getlabeltax(val) {
      let result = _.filter(this.listtax, (item) => item.value == val);
      return result.length > 0 ? result[0].text : "-";
    },
    resetform() {
      this.form.main.resetFields();
      this.form.tax = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.save = true;

        let idpp = this.form.main.getFieldValue("id_pp");
        if (!idpp) {
          this.loading.save = false;
          this.displayMessageValue("error-other", "PP is not Selected!");
          return;
        }

        //let source = _.filter(this.dataSource.usagedetail, (item) => item.tax_type != undefined);
        let source = this.dataSource.usagedetail;
        if (source.length == 0) {
          this.loading.save = false;
          this.displayMessageValue("error-other", "Empty Selected Data of Type Tax!");
          return;
        }

        let data = new FormData();
        data.append("id_pp", idpp);

        source.forEach((item, index) => {
          data.append(`id_pp_dtl[${index}]`, item.id_pp_dtl);
          data.append(`is_tax[${index}]`, item.tax_type && item.tax_type!="undefined" ? "1" : "0");
          data.append(`tax_type[${index}]`, item.tax_type);
        });

        this.asyncAxiosPost(
          this.mode == 'Create' ? "pi" : "pi/edit",
          "formdata",
          this.getAuth,
          data
        )
          .then((response) => {
            if (this.mode == "Create") {
              this.displayMessage("success-save");
            } else {
              this.displayMessage("success-edit");
            }
            this.loading.save = false;
            this.$router.push({ name: "pi" });
          })
          .catch((err) => {
            this.loading.save = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          });
      });
    },
    changetype(e, index) {
      this.dynamicValidateForm.domains[index].value = e;
    }
  }
}
</script>

<style lang="less">
.ant-select-selection-selected-value{
  width: 100%!important
}
</style>